import type { DeviceType } from '@interfaces/chime';
import {
  DefaultAudioMixController,
  TimeoutScheduler,
} from 'amazon-chime-sdk-js';

export class SoundHandler {
  public playTestSound(
    device?: DeviceType,
    frequency = 440,
    durationSec = 1,
    rampSec = 0.1,
  ) {
    if (!device) return;

    const audioContext: AudioContext = new (
      window.AudioContext || window.webkitAudioContext
    )();

    const gainNode = audioContext.createGain();
    gainNode.gain.value = 1;

    const oscillatorNode = audioContext.createOscillator();
    oscillatorNode.frequency.value = frequency;
    oscillatorNode.connect(gainNode);

    const destinationStream = audioContext.createMediaStreamDestination();
    gainNode.connect(destinationStream);

    const currentTime = audioContext.currentTime;
    const startTime = currentTime + 2;
    gainNode.gain.linearRampToValueAtTime(0, startTime);

    oscillatorNode.start();

    const audioMixController = new DefaultAudioMixController();
    audioMixController.bindAudioDevice(device as MediaDeviceInfo);
    audioMixController.bindAudioElement(new Audio());
    audioMixController.bindAudioStream(destinationStream.stream);

    new TimeoutScheduler((rampSec * 2 + durationSec + 1) * 1000).start(() => {
      audioContext.close();
    });
  }
}
